
import { Fingerprint as FingerprintIcon } from '@material-ui/icons/';

import Login from './Login';

export default [
  {
    path     : '/pages/login',
    name     : 'Login Page',
    short    : 'Login',
    mini     : 'LP',
    icon     : FingerprintIcon,
    component: Login,
  },
];
